<template>
    <main-layout>

        <app-header icon="tools">
            Intervention
        </app-header>

        <action-bar :back="{name:'liste-fibsdd'}">
        </action-bar>

        <form class="wrap" @submit.prevent="sendFormFi">

            <label>Vos références si besoin (N° de bon, initiales tech, etc..)</label>
            <input title="ref" type="text" class="dossier" name="ordre_travail" value="" v-model="fibsdd.ordre_travail" maxlength="255" placeholder="Facultatif">

            <label>Numéro de fiche FI</label>
            <input type="text" class="dossier" placeholder="Généré automatiquement si non renseigné" name="numFiche" value="" v-model="fibsdd.numero" maxlength="255">

            <div id="choice-detenteur">

                <h2>DÉTENTEUR</h2>

                <div v-if="!fromDetOrInst">
                    <label for="id_detenteur">Nom *</label>
                    <v-select
                        id="id_detenteur"
                        ref="selectDet"
                        :filterable="false"
                        :on-change="loadInstallations"
                        :options="detenteursFiltred"
                        @search="onSearch"
                        @change="onChange">
                    </v-select>
                </div>
                <div v-else>
                    <label>Détenteur : <span>{{ detString }}</span></label>
                </div>

                <div>
                    <label>Adresse : <span v-if="detSelected" v-text="detSelected.adresse"></span></label>
                    <label>Code postal : <span v-if="detSelected" v-text="detSelected.code_postal"></span></label>
                    <label>Ville : <span v-if="detSelected" v-text="detSelected.ville"></span></label>
                    <label>SIRET : <span v-if="detSelected" v-text="detSelected.siret"></span></label>
                </div>

            </div>

            <div id="choice-install" style="display: none;">

                <h2>INSTALLATION</h2>

                <label>Identification *</label>
                <div class="skin-select">
                    <select @change="loadInstallInfos" v-model="fibsdd.installation"
                            :value="fibsdd.installation">
                        <option selected disabled>Choisissez une installation</option>
                        <option v-for="installation in installations" :key="installation.id" :value="installation.id">
                            {{ installation.nom }}
                            {{ (installation.marque) ? ' - ' + installation.marque : '' }}
                            {{ (installation.modele) ? ' - ' + installation.modele : '' }}
                        </option>
                    </select>
                </div>

                <div v-show="instSelected.hasOwnProperty('charge') && instSelected.fluide !== null">

                    <label>
                        Nature du fluide frigorigène :
                        <span v-if="instSelected.fluide" v-text="instSelected.fluide.nom"></span>
                    </label>
                    <input v-if="instSelected.fluide" type="hidden" name="id_fluide_installation" id="id_fluide_installation" v-model="fibsdd.fluide_init" >

                    <label>
                        Charge totale (Kg) :
                        <span v-if="instSelected" v-text="instSelected.charge"></span>
                    </label>
                    <input type="hidden" name="charge_init" id="charge_init" v-model="fibsdd.charge_init" >

                    <label>
                        Présence d'un détecteur de fuite fixe :
                        <span v-show="instSelected.hasOwnProperty('detecteur')">{{ (instSelected.detecteur === true) ? 'Oui' : 'Non'}}</span>
                    </label>

                    <label>Tonnage équivalent CO<span class="smallexp">2</span> :
                        <span v-if="instSelected" v-text="instSelected.tonnage"></span>
                    </label>

                    <label v-show="instSelected.frequence_controle">
                        Fréquence des contrôles :
                        <span v-if="instSelected.frequence_controle"
                              v-text="instSelected.frequence_controle + ' Mois'"></span>
                    </label>

                </div>


            </div>

            <button class="btn add btn-full" ref="formButton" name="newFiche" :disabled="saving" :class="{disabled: saving}">
                <i class="icon-add"></i>
                <strong>Ajouter</strong>l' intervention
            </button>

        </form>

    </main-layout>
</template>

<script>
    import Detenteur from '../../../js/models/Detenteur'
    import Installation from '../../../js/models/Installation'
    import Fibsdd from '../../../js/models/Fibsdd'

    import vSelect from 'vue-select'

    export default {
        data() {

            return {

                fibsdd: {

                    numero: null,
                    ordre_travail: null,
                    detenteur: null,
                    installation: null,
                    charge_init: null,
                    fluide_init: null,
                    detecteur: null,
                    cloture: false,
                    callback: null,

                    natures : {
                        assemblage: false,
                        miseEnService: false,
                        modification: false,
                        maintenance: false,
                        controlePeriodique: false,
                        controleNonPeriodique: false,
                        demantelement: false,
                        retrofit: false,
                        newFluide: null,
                        autres: null,
                        observations: null,
                        description: null,
                        contractuel: null
                    },

                    ctrlEtanch: {
                        no_fuites: null,
                    },

                    informations: {
                        temps_deplacement: null,
                        temps_intervention: null,
                        heure_arrivee: null,
                        heure_depart: null,
                        kilometrage: null,
                        desc_pieces: null,
                        observations: null,
                        techs:null,
                        namesTechniciens:null,
                        finish:null,
                        garantie: null,
                        fromDevis: null,
                        needDevis: null,
                        preventif: null,
                        correctif: null,
                        travauxEffectues:null,
                    },

                    photos: [],

                    pieces: [],

                    infosDet: {
                        nom_signataire: null,
                        fonction_signataire: null,
                        signature_signataire: null,
                    },

                },

                selected: null,
                detenteursOpt: [],
                detenteursFiltred: [],
                detSelected: null,
                instSelected: {},
                detenteurs: [],
                installations: [],
                fromDetOrInst: false,
                detString: '',
                saving: false

            }

        },
        methods: {

            async sendFormFi() {

                if (this.saving) {
                    return
                }

                let fi = new Fibsdd;
                let router = this.$router;

                if (_.isEmpty(this.detSelected)) {
                    swal('Formulaire incomplet', 'Veuillez sélectionner un détenteur.', 'error');
                } else if (_.isEmpty(this.instSelected)) {
                    swal('Formulaire incomplet', 'Veuillez sélectionner une installation.', 'error');
                } else if (
                    this.instSelected.hasOwnProperty('fluide') &&
                    this.instSelected.fluide !== null &&
                    this.instSelected.fluide.id === 44
                ) {
                    swal('Fluide non autorisé', "Veuillez remplacer le fluide R-999 de l'installation par un fluide existant.", 'error');
                } else {

                    this.saving = true;

                    let payload = Object.assign({}, this.fibsdd);

                    try {

                        if (!payload.numero) {

                            let timestamp = '' + +new Date();
                            payload.numero = timestamp.slice(0, -3)

                        } else {

                            let fibsdds = await fi.getList();
                            let find = _.find(fibsdds, ['numero', payload.numero]);

                            if (find !== undefined) {
                                this.saving = false;
                                swal('Numero utilisé', 'Vous avez déjà une fiche avec ce numéro', 'warning');
                                return
                            }

                        }

                        let data = await fi.addOfflineFibsdd(payload);
                        router.push({name: 'fibsdd', params: {id: data}})

                    } catch (e) {
                        this.saving = false;
                        swal('Erreur', "L'intervention n'a pas pu être créée, veuillez réessayer.", 'error')
                    }

                }

            },

            onChange() {

            },

            loadDetenteurs() {
                return new Promise((resolve, reject) => {
                    Detenteur.getList().then(data => {
                        let dets = _.sortBy(data,  [det => det.raison_sociale.toUpperCase()]);
                        this.detenteurs = dets;

                        this.detenteursOpt = dets.map(det => {
                            let label = det.raison_sociale;
                            label += (det.code_client) ? ' (' + det.code_client + ') - ' : ' - ';
                            label += det.ville + ' / ' + det.code_postal;
                            let value = det.id;

                            return { value, label }
                        });

                        this.detenteursFiltred = this.detenteursOpt.slice(0, 20);
                        this.onSearch('', false);

                        resolve(this.detenteursOpt);

                    }).catch(() => {
                        reject('Erreur getDetenteurs')
                    })
                })
            },

            onSearch(str) {
                str = this.normalize(str);

                this.detenteursFiltred = this.detenteursOpt.filter( det =>  {
                    if(this.normalize(det.label).includes(str)) { return det }
                }).slice(0, 20)
            },

            normalize(s) {
                let r = s.toLowerCase();

                r = r.replace(new RegExp(/\s/g),"");
                r = r.replace(new RegExp(/[àáâãäå]/g),"a");
                r = r.replace(new RegExp(/æ/g),"ae");
                r = r.replace(new RegExp(/ç/g),"c");
                r = r.replace(new RegExp(/[èéêë]/g),"e");
                r = r.replace(new RegExp(/[ìíîï]/g),"i");
                r = r.replace(new RegExp(/ñ/g),"n");
                r = r.replace(new RegExp(/[òóôõö]/g),"o");
                r = r.replace(new RegExp(/œ/g),"oe");
                r = r.replace(new RegExp(/[ùúûü]/g),"u");
                r = r.replace(new RegExp(/[ýÿ]/g),"y");
                r = r.replace(new RegExp(/\W/g),"");

                return r;
            },

            loadInstallations(val) {
                if (!val) return Promise.resolve(false);
                return new Promise((resolve, reject) => {
                    this.fibsdd.detenteur = val.value;
                    this.detSelected = _.find(this.detenteurs, ['id', val.value]);

                    Installation.getInstallationsForDet(val.value).then(list => {
                        this.installations = _.sortBy(list, [i => i.nom.toUpperCase()]);
                        document.getElementById('choice-install').style.display = "block";
                        this.instSelected = {};
                        return resolve(true);
                    }).catch(err => reject(err))
                });
            },

            loadInstallInfos() {
                this.instSelected = _.find(this.installations, ['id', this.fibsdd.installation]) || {};
                if (this.instSelected.fluide) {
                    this.fibsdd.charge_init = this.instSelected.charge;
                    this.fibsdd.fluide_init = this.instSelected.fluide.id
                }
            },

        },
        mounted: function () {

            if(this.$route.query.num_ot) {
                this.fibsdd.ordre_travail = this.$route.query.num_ot;
            }

            // Récupérer le callback s'il est présent dans les query params (décodage base64)
            if (this.$route.query.callback) {
                try {
                    this.fibsdd.callback = atob(this.$route.query.callback);
                } catch (e) {
                    console.error('Erreur lors du décodage du callback:', e);
                }
            }

            this.loadDetenteurs()
                .then(() => {
                    if (this.$route.query.detenteur) {
                        this.fromDetOrInst = true;

                        let det;
                        if (_.includes(this.$route.query.detenteur, 'N-')) {
                            det = this.$route.query.detenteur;
                        } else {
                            det = parseInt(this.$route.query.detenteur);
                        }

                        this.fibsdd.detenteur = det;
                        const detObj = _.find(this.detenteurs, ['id', det]);
                        this.detSelected = detObj;

                        let label = detObj.raison_sociale;
                        label += (detObj.code_client) ? ' (' + detObj.code_client + ') - ' : ' - ';
                        label += detObj.ville + ' / ' + detObj.code_postal;
                        this.detString = label;


                        this.loadInstallations({value: det})
                            .then(() => {
                                if (this.$route.query.installation) {

                                    if (_.includes(this.$route.query.installation, 'N-')) {
                                        this.fibsdd.installation = this.$route.query.installation;
                                    } else {
                                        this.fibsdd.installation = parseInt(this.$route.query.installation);
                                    }

                                    this.loadInstallInfos()


                                }
                            })
                            .catch();


                    }
                })
                .catch(err => {
                    console.error('Erreur lors de l\'initialisation depuis les query params:', err);
                });

        },
        components: {
            vSelect
        }
    }
</script>

<style scoped>

    h2 {
        font-size: 2.0rem;
        text-transform: uppercase;
        font-weight: 700;
        margin-bottom: 15px;
        margin-top: 10px;
    }

    form {
        padding-bottom: 25px;
    }

</style>



// WEBPACK FOOTER //
// NewFibsdd.vue?698e6b78